import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Comps from './components/index'
// import store from './store';
// import '@/utils/config'

import Vant from 'vant';
import 'vant/lib/index.css';


Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Comps);
Vue.use(Vant);

// // 进入Vue App之前，检查URL的查询字符串是否有accessToken和refreshToken，如果有则写入localStorage
// let queryStr = location.search.slice(1);
// let query = qs.parse(queryStr);

// let { accessToken, dataType } = query;
// if (
//   accessToken &&
//   dataType
// ) {
//   localStorage.setItem("accessToken", accessToken);
//   localStorage.setItem("dataType", dataType);
//   // location.href = location.origin + "/home";
// }

// if (!accessToken && !localStorage.getItem("accessToken", accessToken)) {
//   accessToken = localStorage.getItem("accessToken");
//   let loginQuery = {
//     redirectType: "screen",
//     redirect: location.origin + location.pathname // 大屏自身URL
//   };
//   let loginQueryStr = qs.stringify(loginQuery);
//   let loginOrigin = process.env.VUE_APP_local_yly; // 养老云URL
//   location.href = `${loginOrigin}?${loginQueryStr}`;
// }

new Vue({
  router,
  // store,
  render: function(h) {
    return h(App);
  }
}).$mount("#app");
